function totalPrice(
  products,
  desperdicio,
  m2Solicitados,
  obraEstimativa,
  qtyObraEstimativa
) {
  let sum = 0;
  products.map(
    product =>
      (sum +=
        (product.m2qty + product.m2qty * desperdicio) *
        m2Solicitados *
        product.prod.pricem2)
  );
  return (
    sum + totalPriceObraEstimativa(obraEstimativa, qtyObraEstimativa)
  ).toFixed(2);
}

function totalPriceComercial(
  products,
  desperdicio,
  m2Solicitados,
  obraEstimativa,
  qtyObraEstimativa
) {
  let sum = 0;
  products.map(
    product =>
      (sum += totalComercialPrice(
        product.m2qty,
        desperdicio,
        m2Solicitados,
        product.prod.sup,
        product.prod.priceud
      ))
  );
  return (
    sum + totalPriceObraEstimativa(obraEstimativa, qtyObraEstimativa)
  ).toFixed(2);
}

function totalPriceObraEstimativa(price, quantity) {
  return price * quantity;
}

function totalQty(m2Qty, waste, m2get) {
  return (m2Qty + m2Qty * waste) * m2get;
}

function pricePerm2(m2Qty, pricem2) {
  return m2Qty / pricem2;
}

function totalPriceProduct(m2Qty, waste, m2get, priceUD) {
  return totalQty(m2Qty, waste, m2get) * priceUD;
}

function comercialQuantity(m2Qty, waste, m2get, sup) {
  return Math.ceil(totalQty(m2Qty, waste, m2get) / sup);
}

function totalComercialPrice(m2Qty, waste, m2get, sup, priceUD) {
  return comercialQuantity(m2Qty, waste, m2get, sup) * priceUD;
}

function totalPriceAlt(
  products,
  alternativeprods,
  waste,
  m2get,
  obraEstimativa,
  qtyObraEstimativa
) {
  let sum = 0;

  products.map(
    product =>
      (sum +=
        (product.m2qty + product.m2qty * waste) * m2get * product.prod.pricem2)
  );

  alternativeprods.map(
    product =>
      (sum +=
        (product.m2qty + product.m2qty * waste) * m2get * product.prod.pricem2)
  );

  let sum2 = 0;

  alternativeprods
    .filter(p => p.idProductToReplace !== 0)
    .map(
      produ =>
        //Hay que buscar por posicion por que si va por id despues puede no encontrarlo
        (sum2 +=
          (products[produ.idProductToReplace].m2qty +
            products[produ.idProductToReplace].m2qty * waste) *
          m2get *
          products[produ.idProductToReplace].prod.pricem2)
    );

  return (
    sum -
    sum2 +
    totalPriceObraEstimativa(obraEstimativa, qtyObraEstimativa)
  ).toFixed(2);
}

function totalPriceComercialAlt(
  products,
  alternativeprods,
  waste,
  m2get,
  obraEstimativa,
  qtyObraEstimativa
) {
  let sum = 0;
  products.map(
    product =>
      (sum += totalComercialPrice(
        product.m2qty,
        waste,
        m2get,
        product.prod.sup,
        product.prod.priceud
      ))
  );

  alternativeprods.map(
    product =>
      (sum += totalComercialPrice(
        product.m2qty,
        waste,
        m2get,
        product.prod.sup,
        product.prod.priceud
      ))
  );

  let sum2 = 0;
  alternativeprods
    .filter(p => p.idProductToReplace !== 0)
    .map(
      product =>
        (sum2 += totalComercialPrice(
          product.m2qty,
          waste,
          m2get,
          product.prod.sup,
          product.prod.priceud
        ))
    );

  return (
    sum -
    sum2 +
    totalPriceObraEstimativa(obraEstimativa, qtyObraEstimativa)
  ).toFixed(2);
}

export {totalQty, totalPriceProduct, comercialQuantity, totalComercialPrice, totalPriceObraEstimativa, totalPrice, totalPriceComercial, totalPriceAlt, totalPriceComercialAlt};